import React from 'react';
import clsx from 'clsx';
import style from './HeaderMenuIconButton.module.scss';
export function HeaderMenuIconButton({ label, icon, iconHover, isActive = false, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx(style.imgWrapper, { [style.activeImg]: isActive }), style: { width: 30, height: 30 } },
            React.createElement("img", { alt: label, width: 30, height: 30, src: icon, className: style.defaultImg }),
            React.createElement("img", { alt: label, width: 30, height: 30, src: iconHover, className: style.hoverImg })),
        React.createElement("div", { className: clsx(style.text, { [style.activeText]: isActive }) }, label)));
}
